var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialMediaXing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_in_Pfaden"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Social-Media"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M35.8,1.1L22.4,21.5v0l8.6,13.4c0.2,0.3,0.2,0.6,0,0.8c-0.2,0.2-0.4,0.3-0.8,0.3H24 c-0.7,0-1.3-0.3-1.7-1l-8.7-13.5C14,21,18.5,14.2,27.3,1c0.4-0.7,1-1,1.6-1H35c0.4,0,0.6,0.1,0.8,0.3C36,0.6,36,0.8,35.8,1.1z  M11.1,8.1l4.2,6.2c-0.2,0.3-2.4,3.6-6.6,9.9c-0.5,0.7-1,1-1.7,1H0.9c-0.4,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.2-0.5,0-0.8l6.5-9.8 c0,0,0,0,0,0L2.5,8.2c-0.2-0.3-0.2-0.6,0-0.8c0.2-0.2,0.4-0.3,0.8-0.3h6.1C10.1,7.1,10.6,7.4,11.1,8.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialMediaXing);
export default __webpack_public_path__ + "static/media/icon-social-media-xing.0779dc027b53ca7963de156da4ed3f53.svg";
export { ForwardRef as ReactComponent };